import { BodyText, Box } from 'vopay';
import { FunctionComponent, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { UtilButton, Title } from 'UI';
import { useTranslation } from 'react-i18next';
// import SuperAdmins from './SuperAdmins';
import styles from './ApprovalRoles.module.scss';

import Approvers from './Approvers';

type FC = FunctionComponent;

const ApprovalRolesContainer: FC = () => {
  const { t } = useTranslation('translations', { keyPrefix: 'TransactionApproval.Configuration.Roles.List' });
  const { t: tGlobal } = useTranslation('translations', { keyPrefix: 'Global' });
  const history = useHistory();
  const [editingSection, setEditingSection] = useState<'superAdmin' | 'approvers' | null>(null);

  return (
    <div className={styles.container}>
      <Box flx="col" gapSize="16px">
        <UtilButton
          iconLeft="chevron_left"
          size="large"
          onClick={() => {
            if (history.length > 1) {
              history.goBack();
            } else {
              history.replace('/transaction-approval/configuration');
            }
          }}
        >
          {tGlobal('Buttons.back')}
        </UtilButton>
        <Box flx="col" gapSize="6px">
          <Title>{t('title')}</Title>
          <BodyText style={{ color: '#2D2D2DBF' }}>{t('instructions')}</BodyText>
        </Box>
      </Box>
      <Box flx="col" gapSize="24px" base="8" pt="xmd">
        {/* <SuperAdmins
          isDisabled={editingSection === 'approvers'}
          onEdit={(isEditing) => setEditingSection(isEditing ? 'superAdmin' : null)}
        /> */}
        <Approvers
          isDisabled={editingSection === 'superAdmin'}
          onEdit={(isEditing) => setEditingSection(isEditing ? 'approvers' : null)}
        />
      </Box>
    </div>
  );
};
export default ApprovalRolesContainer;
